import React, { FunctionComponent, useRef } from 'react'
import styled from 'styled-components'
import { AssetImage } from '../components/image'
import { DetailTable } from '../components/detail-table'
import { useBreakpoint } from '../hooks/use-break-point'
import { pageMaxWidth } from '../styles/page-max-width'
import { headEnText, headJaText } from '../styles/text-styles'
import { SlimDetailTable } from '../components/slim-detail-table'

const Outer = styled.div`
  ${pageMaxWidth}
  padding-top: 8rem;
  padding-bottom: 8rem;
  font-family: var(--sans-serif-font);
`

const Inner = styled.div`
`

const Head = styled.div`
  ${headEnText}
`

const Nav = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 3rem;
  flex-wrap: wrap;
  @media (max-width: 40rem){
    margin-top: 2rem;
    flex-direction: column;
    align-items: flex-start;
  }
  
`

const NavItem = styled.a`
  padding: 0.5rem 2rem;
  display: block;
  background-color: white;
  white-space: nowrap;
`

const Section = styled.div`
  margin-top: 4rem;
  scroll-margin-top: 3rem;
  @media (max-width: 40rem){
  }
`

const SectionHead = styled.div`
  font-size: 1.25rem;
`

const Text = styled.div`
  font-size: 0.875rem;
  line-height: 1.75;
  margin-top: 1rem;
  margin-bottom: 1rem;
`

const ImageLabel = styled.div`
  margin-bottom: 1rem;
`

const ImageContainer = styled.div`
  img {
    display: block;
    width: 100%;
    height: auto;
  }
`

const DetailContainer = styled.div`
  margin-top: 3rem;
`

const Text2 = styled.div`
  line-height: 2;
  text-align: center;
  margin-top: 4rem;
  @media (max-width: 40rem){
    text-align: left;
  }
`

type PointPageProps = {

}
export const PointPage: FunctionComponent<PointPageProps> = () => {
  const isMobile = useBreakpoint('40rem')
  const outerRef = useRef<HTMLDivElement>(null)
  return <Outer ref={outerRef}>
    <Inner>
      <Head>
        ポイント制度について
      </Head>
      {/* <Nav>
        <NavItem href="#1" onClick={e => {
          e.preventDefault()
          const outer = outerRef.current
          console.log(outer)
          if(outer){
            outer.querySelector('#s1')?.scrollIntoView({behavior: 'smooth'})
          }
        }}>
          会員ステージと特典
        </NavItem>
        <NavItem href="#2" onClick={e => {
          e.preventDefault()
          const outer = outerRef.current
          if(outer){
            outer.querySelector('#s2')?.scrollIntoView({behavior: 'smooth'})
          }

        }}>
          ステージ判定期間
        </NavItem>
        <NavItem href="#3" onClick={e => {
          e.preventDefault()
          const outer = outerRef.current
          if(outer){
            outer.querySelector('#s3')?.scrollIntoView({behavior: 'smooth'})
          }

        }}>
          ポイントの有効期限
        </NavItem>
      </Nav> */}
      {/* <Section id="s1">
        <SectionHead>
          会員ステージと特典
        </SectionHead>
        <Text>
          スキンメドの会員制度では「ブロンズ」「シルバー」「ゴールド」の3つをご用意。お買い上げ金額と定期購入の有無をもとに判定させていただきます。<br />
          貯まったポイントは1point=1円としてご購入時にご利用いただけます。
        </Text>
        <ImageContainer>
          {
            isMobile ? 
            <AssetImage src="point-1m.webp"/>:
            <AssetImage src="point-1.webp"/>
          }
        </ImageContainer>
      </Section>
      <Section id="s2">
        <SectionHead>
          ステージ判定期間
        </SectionHead>
        <Text>
          会員ステージは、最新注文の出荷完了後に決定し、更新されます。
        </Text>
        <ImageLabel>
          ＜ステージ判定のイメージ＞
        </ImageLabel>
        <ImageContainer>
          {
            isMobile ? 
            <AssetImage src="point-2m.webp"/>:
            <AssetImage src="point-2.webp"/>
          }
        </ImageContainer>
      </Section> */}
      <Section id="s3">
        <SectionHead>
          ポイントの有効期限
        </SectionHead>
        <Text>
          ポイント毎に有効期限があります。ご購入日にポイントが付与され、1年有効です。
        </Text>
        <ImageLabel>
          ＜ポイント有効期限のイメージ＞
        </ImageLabel>
        <ImageContainer>
          {
            isMobile ? 
            <AssetImage src="point-3m.jpg"/>:
            <AssetImage src="point-3.jpg"/>
          }
        </ImageContainer>
      </Section>
      <Section>
        <SectionHead>
          ポイントについてのよくある質問
        </SectionHead>
        <DetailContainer>
          <SlimDetailTable
            items={[
              // {
              //   label: '会員ステージの対象期間を教えてください。',
              //   value: <>
              //   直近６ヶ月間の累計購入金額と現在の定期購入の有無で判定いたします。
              //   </>
              // },
              {
                label: 'ポイントの有効期限はありますか？',
                value: <>
                  お買い上げポイントは付与日より1年間有効です。<br />
                  ポイント付与（更新）のタイミングは「発送完了後」になります。
                </>
              },
              // {
              //   label: '会員ランクが変わった際には連絡はありますか？',
              //   value: <>
              //     会員ランクが変わった際にはメールなどでご連絡いたします。<br />
              //     また、現在のランクはマイページにてご確認いただけます。
              //   </>
              // },
              {
                label: '継続中の定期コースでもポイントは使えますか？',
                value: <>
                  ご利用いただけます。マイページよりお手続きください。<br />
                  初めてお買い上げの商品にも定期コースの商品にもポイントはご利用いただけます。<br />
                  ご利用方法はマイページをご確認ください。
                </>
              }
            ]}
          />
        </DetailContainer>
      </Section>
    </Inner>
  </Outer>
}